import React from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Advantages from "./components/Advantages";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function PublicSite() {
  return (
    <div className="page">
      <Nav />
      <main>
        <Hero />
        <Advantages />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
